import delay from "../utilities/delay.js";
import isFocused from "./isFocused.js";
import togglePlaceholder from "./togglePlaceholder.js";
import toggleHighlight from "./toggleHighlight.js";
import blazorUpdate from "./blazorUpdate.js";
import focus from "./focus.js";

const closeBubble = async (element) => {
    await delay(500);

    if (isFocused(element)) {
        closeBubble(element);
        return;
    }

    if (!element._quill) {
        return;
    }

    blazorUpdate(element);

    const quill = element.querySelector('.ra-quill');
    let html = element._quill.getSemanticHTML();
    html = html.replace('<a ', '<a target="_blank" onclick="event.stopPropagation();" contenteditable="false" ');
    html = html.replace('del>', 's>');
    quill.innerHTML = html;
    element._quill = undefined;
    element.dataset.quill = 'false';

    element.setAttribute("contenteditable", true);
    element.addEventListener('focus', focus);
    togglePlaceholder(element);
    toggleHighlight(element);
};

export default (element) => {
    closeBubble(element);
};
